<db-cdn-enable-banner [websiteId]="websiteId" *ngIf="currentSubscription?.boosterProClient"></db-cdn-enable-banner>
<div class="db-optimize-images" [ngClass]="{'loading': ((loadingWebpFormat || loading) && !pageLayout)}">
  <div class="db-optimize-images__header">
    <!--<img src="assets/images/booster/optimize-images.png" alt="">-->
    <div [ngClass]="{'ds-lazy-load': (loadingWebpFormat || !(optimizeImagesStats$ | async)) && !pageLayout}">
      <h1 [innerHTML]="'text_speedOptimizerTitle' | dbText"></h1>
      <p [innerHTML]="'text_speedOptimizerDesc' | dbText"></p>
    </div>
  </div>

  <div class="db-optimize-images__content">
    <div class="db-optimize-images__images">
      <div class="db-optimize-images__block {{loadingWebpFormat}} {{!(optimizeImagesStats$ | async)}}" [ngClass]="{'ds-lazy-load': (loadingWebpFormat || !(optimizeImagesStats$ | async)) && !pageLayout}">
        <div class="db-optimize-images__ready-optimize" [ngClass]="{'all-optimize': !loading && !stats?.notCompressed && !stats?.notCompressedFull}">
          <i class="db-icon db-icon-info-lined" [dsTooltip]="'text_speedOptimizerTooltip' | dbText"
             dsTooltipPosition="bottom" dsTooltipAlign="right"></i>
          <div>
            <div class="db-optimize-images__all-optimized">
              <i class="db-icon db-icon-ds-circle-filled" *ngIf="!loading && !stats?.notCompressed && !stats?.notCompressedFull"></i>
            </div>
            <p class="db-optimize-images__ready-optimize-title" *ngIf="!(!loading && !stats?.notCompressed && !stats?.notCompressedFull)"
               [innerHTML]="'text_speedOptimizerImagesCount' | dbText : {count: stats?.notCompressed || 0}">
            </p>
            <p class="db-optimize-images__ready-optimize-desc" *ngIf="!(!loading && !stats?.notCompressed && !stats?.notCompressedFull)"
               [innerHTML]="'text_ioOptimizerNoImages' | dbText : {count: stats?.notCompressed || 0, full: stats?.notCompressedFull || 0}">
            </p>
            <p class="db-optimize-images__ready-optimize-text">
              <span>{{((!loading && !stats?.notCompressed && !stats?.notCompressedFull) ? 'text_speedOptimizerAllSet' : (stats?.notCompressed ? 'text_optimizerReadyToBeOptimized' : 'text_speedOptimizerNoImagesOptimize')) | dbText}}</span>
            </p>
            <p class="db-optimize-images__ready-optimize-desc all-optimized" *ngIf="!loading && !stats?.notCompressed && !stats?.notCompressedFull"
               [innerHTML]="'text_ioOptimizerImagesAllOptimized' | dbText : {count: stats?.compressedFull + stats?.compressedThumbs + stats?.compressedOther, full: stats?.compressedFull}">
            </p>
          </div>
        </div>
      </div>
      <div class="db-optimize-images__block" [ngClass]="{'ds-lazy-load': (loadingWebpFormat || !(optimizeImagesStats$ | async)) && !pageLayout}">
        <div class="pb20">
          <div>
            <p class="db-optimize-images__block-title" [innerHTML]="stats?.lastCompressedSize | size: {unit: 'MB'} + 'MB (' + stats?.lastCompressedPercent + '%)'"></p>
            <span class="db-optimize-images__block-desc">{{'text_lastOptimization' | dbText}}</span>
          </div>
        </div>
        <div class="pb20">
          <div>
            <p class="db-optimize-images__block-title" [innerHTML]="stats?.reducedSize | size: {unit: 'MB'} + 'MB (' + stats?.reducedPercent + '%)'"></p>
            <span class="db-optimize-images__block-desc">{{'text_total' | dbText}}</span>
          </div>
        </div>
        <a class="ds-btn-blue" [ngClass]="{'ds-btn-disabled': loading || (!loading && !stats?.notCompressed && !stats?.notCompressedFull)}" (click)="optimizeImages()">
          <span *ngIf="!loading">{{'text_speedOptimizerNow' | dbText | lowerCaseSpecificWords}}</span>
          <span class="ds-spinner-circle"  *ngIf="loading"></span>
        </a>
      </div>
    </div>

    <div class="db-optimize-images__notification" *ngIf="currentSubscription?.trialBoosterClient">
      <div class="ds-notification-success success-notification">
        <div>
          <i class="db-icon db-icon-ds-checkmark-bg"></i>
          <span>Images on the homepage and 5 inner pages included in your free plan are optimized automatically.</span>
        </div>
      </div>

      <div class="ds-notification-error" *ngIf="error">
        <div>
          <i class="db-icon db-icon-ds-close-bg"></i>
          <span [innerHTML]="'text_speedOptimizerWentWrong' | dbText"></span>
        </div>
      </div>
    </div>


    <form [formGroup]="imageOptimizerSettings">
      <div class="db-optimize-images__block" [ngClass]="{'ds-lazy-load': (loadingWebpFormat || !(optimizeImagesStats$ | async)) && !pageLayout}">
        <db-loading-screen *ngIf="loadingAutoOptimize"></db-loading-screen>
        <div>
          <div>
            <p class="db-optimize-images__block-title" [innerHTML]="'text_speedOptimizerAutomaticOptimization' | dbText"></p>
            <span class="db-optimize-images__block-desc" [innerHTML]="'text_frontendSpeed5-tooltip-body' | dbText"></span>
          </div>
          <div class="db-switch-wrap">
            <input id="auto-optimize-switcher" class="ds-switcher-green ds-control-small auto-optimize-settings" type="checkbox"
                   (change)="setAutoOptimize()" formControlName="autoOptimize">
            <label for="auto-optimize-switcher">
              <span class="ds-switcher-control"></span>
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="!pageLayout && !websiteHosted"
           class="db-optimize-images__block"  [ngClass]="{'ds-lazy-load': (loadingWebpFormat || !(optimizeImagesStats$ | async)) && !pageLayout}">
        <div>
          <div>
            <p class="db-optimize-images__block-title" [innerHTML]="'text_speedOptimizerWebPFormat' | dbText"></p>
            <span class="db-optimize-images__block-desc"
                  [innerHTML]="(websiteHosted ? 'text_speedOptimizerWebPFormatHostedDesc' : 'text_speedOptimizerWebPFormatDesc') | dbText"></span>
          </div>
          <div class="db-switch-wrap"
               [ngClass]="{'hidden': boosterSettings?.hosting === 'APACHE' && !boosterSettings?.htaccessWritable}"
               *ngIf="(!!boosterSettings?.webpDeliveryWorking && boosterSettings?.hosting !== 'NGINX')">
            <input id="webp-switcher" class="ds-switcher-green ds-control-small auto-optimize-settings" type="checkbox"
                   (change)="setWebpStatus()" formControlName="webpStatus" [value]="boosterSettings?.webpStatus">
            <label for="webp-switcher">
              <span class="ds-switcher-control"></span>
            </label>
          </div>
        </div>

        <div class="db-optimize-images__note" *ngIf="websiteId && boosterSettings && !websiteHosted
        && ((!boosterSettings?.webpStatus && !['10Web', 'NGINX', 'APACHE'].includes(boosterSettings.hosting)) || !boosterSettings?.webpDeliveryWorking)">
          <div>
            <h3 [innerHTML]="'text_serverConfiguration' | dbText"></h3>
            <div>
              <div class="db-optimize-images__note-info">
                <p class="db-optimize-images__block-desc note">
                  <span [innerHTML]="'text_speedOptimizerNote' | dbText"></span>
                  <a (click)="showWebPServerDialog()">these instructions</a>
                </p>
                <p class="db-optimize-images__block-desc note">
                  <span [innerHTML]="'text_speedOptimizerNoteAfterCompleting' | dbText"></span>
                </p>
              </div>
              <div class="db-optimize-images__webp-status" (click)="getWebpStatus()"
                   [ngClass]="{'active': webpServerConfigIsActive, 'inactive': !webpServerConfigIsActive}">
                <p>
                  <i class="db-icon db-icon-{{webpServerConfigIsActive ? 'ds-circle-filled' : 'ds-close-bg'}}"></i>
                  <span>{{webpServerConfigIsActive ? 'Active' : 'Inactive'}}</span>
                </p>
                <i class="db-icon db-icon-ds-refresh"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="db-optimize-images__note use-picture"
             *ngIf="websiteId && !websiteHosted && boosterSettings && ((!boosterSettings?.webpStatus && !['10Web', 'NGINX', 'APACHE'].includes(boosterSettings.hosting)) || !boosterSettings?.webpDeliveryWorking) && !webpServerConfigIsActive">
          <div>
            <h3>{{'text_usePictureTags' | dbText}}</h3>
            <div>
              <div class="db-optimize-images__note-info">
                <p class="db-optimize-images__block-desc note">
                  <span>{{'text_usePictureTagsDesc1' | dbText}}</span>
                </p>
                <p class="db-optimize-images__block-desc note">
                  <span>{{'text_usePictureTagsDesc2' | dbText}}</span>
                </p>
              </div>
              <div class="db-switch-wrap">
                <input id="picture-tag-switcher" class="ds-switcher-green ds-control-small auto-optimize-settings" type="checkbox"
                       (change)="setWebpStatus()" formControlName="pictureWebpStatus">
                <label for="picture-tag-switcher">
                  <span class="ds-switcher-control"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</div>
